import { Component, ElementRef } from '@angular/core';
import { LayoutService } from "../../service/layout.service";
import { MenuComponent } from './menu.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  imports: [MenuComponent],
})
export class SidebarComponent {
    constructor(public layoutService: LayoutService, public el: ElementRef) { }
}

